module.exports = __webpack_public_path__ + "img/remark_03.29e112e7.svg";